import { createSlice } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import {
  createWebBookerT,
  webBookersT,
  WebBooker,
  webBookerT,
} from "dora-contracts";
import axios, { getData } from "../../../axios";
import * as tPromise from "io-ts-promise";

const prefix = "data/web-bookers";

type State = { webBookers: WebBooker[] };

export const createWebBooker = createErrorReportingAsyncThunk(
  `${prefix}/create`,
  async (input: {
    clientId: string;
    firstName: string;
    lastName: string;
    email: string;
  }) =>
    axios
      .post("/api/web-bookers", createWebBookerT.encode(input))
      .then(getData)
      .then(tPromise.decode(webBookerT))
);

export const deleteWebBooker = createErrorReportingAsyncThunk(
  `${prefix}/delete-web-booker`,
  async (input: { webBookerId: string }) => {
    const { webBookerId } = input;
    await axios.delete(`/api/web-bookers/${webBookerId}`);
  }
);

export const getAll = createErrorReportingAsyncThunk(
  `${prefix}/get-all`,
  async () => {
    return axios
      .get("/api/web-bookers")
      .then(getData)
      .then(tPromise.decode(webBookersT));
  }
);

const initialState: State = {
  webBookers: [],
};

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createWebBooker.fulfilled, (state, action) => {
        state.webBookers.push(action.payload);
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.webBookers = action.payload;
      })
      .addCase(deleteWebBooker.fulfilled, (state, action) => {
        state.webBookers = state.webBookers.filter(
          (wb) => wb.id !== action.meta.arg.webBookerId
        );
      });
  },
});

export default slice.reducer;
